<template>
    <c-dialog ref="dialog" title="修改退货信息" width="600" mask-close>
        <c-form ref="form" vertical unit-width="100%">
            <c-form-item label="退货人" required>
                <c-input name="returnee_name" placeholder="请输入退货人姓名" maxlength="50"></c-input>
            </c-form-item>
            <c-form-item label="退货人手机号" required>
                <c-input name="returnee_phone" placeholder="请输入退货人手机号" maxlength="20"></c-input>
            </c-form-item>
            <c-form-item label="退货地址" required>
                <c-input name="returnee_address" placeholder="请输入省市区及详细街道" maxlength="200"></c-input>
            </c-form-item>
        </c-form>

        <template #button>
            <c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
            <c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
export default {
    name: 'purchaseReturnEdit',

    data() {
        return {
            returnOrder: {}
        }
    },

    methods: {
        open(data = {}) {
            this.returnOrder = data.returnOrder || {};
            this.$nextTick(() => {
                this.$refs.form.set({
                    returnee_name: this.returnOrder.returnee_name || '',
                    returnee_phone: this.returnOrder.returnee_phone || '',
                    returnee_address: this.returnOrder.returnee_address || ''
                });
            });
            this.$refs.dialog.open();
        },

        submitHandle() {
            this.$refs.form.submit({
                url: '/purchase/return/edit',
                rule: {
                    returnee_name: '请输入退货人姓名',
                    returnee_phone: '请输入退货人手机号',
                    returnee_address: '请输入退货地址'
                },
                dataFormatter: data => {
                    return Object.assign({}, data, {
                        purchase_return_order_id: this.returnOrder.id
                    });
                },
                success: (data, msg) => {
                    this.$message({message: msg || '修改退货信息成功', type: 'success'});
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>
